import { render, staticRenderFns } from "./ApprovedTrainings.vue?vue&type=template&id=a09beca8&scoped=true"
import script from "./ApprovedTrainings.vue?vue&type=script&lang=js"
export * from "./ApprovedTrainings.vue?vue&type=script&lang=js"
import style0 from "./ApprovedTrainings.vue?vue&type=style&index=0&id=a09beca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09beca8",
  null
  
)

export default component.exports